import React from "react"
import { Row, Col } from "react-bootstrap"
import { SectionTitle } from "@components/Banners/SectionTitle"
import { removeLinkRelNoopenerNoreferrer } from "../../../../utils/urls"

export default function CompetitionDescriptionText({
  competitionName,
  competitionDescription,
}: {
  competitionName: string
  competitionDescription?: string | null
}) {
  return competitionDescription ? (
    <Row>
      <Col>
        <div className="text-section">
          <div className="text-div">
            <SectionTitle title={competitionName} />
            <div
              className="competitionDescriptionContainer"
              dangerouslySetInnerHTML={{
                __html: removeLinkRelNoopenerNoreferrer(competitionDescription) ?? "",
              }}
            ></div>
          </div>
        </div>
      </Col>
    </Row>
  ) : (
    <></>
  )
}
